<template>
        <div class="subdivisionBox">
            <div class="subdivisionTop">
                <div
                    v-for="(item, index) in navList"
                    :key="index"
                    class="subdivisionTopItem"
                    :class="{ 'active':isactive===index}"
                    @click="handleActive(index)"
                >{{item}}</div>
            </div>
            <div id="subdivisionBar" class="subdivisionBar"></div>
        </div>
</template>
<script>
    import echart from 'echarts';
    export default {
        name: 'SinceritySubdivisionBar',
        props: ['experience', 'quality', 'standard'],
        data () {
            return {
                navList: ['规范指数', '品质指数', '体验指数'],
                isactive: 0,
                experience1: [],
                quality1: [],
                standard1: [],
                myChartBar: {}
            };
        },
        mounted () {
            this.myChartBar = echart.init(
                document.getElementById('subdivisionBar')
            );
            this.initBar(this.standard);
        },
        watch: {
            experience (val) {
                this.experience = val;
                this.initBar(this.standard);
            },
            quality (val) {
                this.quality = val;
            },
            standard (val) {
                this.standard = val;
            }
        },
        methods: {
            initBar (newData) {
                let interval = 1;
                let min = Infinity;
                let max = -Infinity;
                let data = echart.util.map(newData, function (item, index) {
                    let x0 = index;
                    let x1 = index + 1;
                    min = Math.min(min, x0);
                    max = Math.max(max, x1);
                    return [x0, x1, item];
                });
                let barOptions = {
                    title: {
                        show: false
                    },
                    color: ['rgb(25, 183, 207)'],
                    grid: {
                        left: '5%',
                        right: '5%',
                        bottom: '3%',
                        containLabel: true
                    },
                    xAxis: [
                        {
                            type: 'value',
                            min: min,
                            max: max,
                            interval: interval,
                            axisLabel: {
                                show: true,
                                align: 'center',
                                color: '#999'
                            },
                            axisLine: {
                                show: false
                            },
                            axisTick: {
                                show: false,
                                alignWithLabel: false
                            },
                            splitLine: {
                                show: false,
                                lineStyle: {
                                    color: '#F5F5F5'
                                }
                            }
                        }
                    ],
                    yAxis: [
                        {
                            name: '数量（家）',
                            splitNumber:3,
                            nameTextStyle: {
                                color: '#999'
                            },
                            type: 'value',
                            axisLine: {
                                show: false
                            },
                            axisLabel: {
                                color: '#999'
                            },
                            axisTick: {
                                show: false
                            },
                            splitLine: {
                                show: true,
                                lineStyle: {
                                    color: '#F5F5F5'
                                }
                            }
                        }
                    ],
                    series: [
                        {
                            name: 'height',
                            type: 'custom',
                            barWidth:'100%',
                            renderItem: this.renderItem,
                            label: {
                                normal: {
                                    show: true,
                                    position: 'top',
                                    color: '#36B374',
                                    fontSize:10,
                                }
                            },
                            itemStyle: {
                                color: ['rgba(207,237,221,1)'],
                                borderColor: '#36B374',
                                borderWidth:'1',
                                // opacity: 0.6 
                            },
                            encode: {
                                x: [0, 1],
                                y: 2,
                                tooltip: 2,
                                label: 2
                            },
                            data: [10, 52, 200, 334, 390, 330, 220, 120, 190, 250]
                        }
                    ]
                }
                barOptions.series[0].data = data;
                this.myChartBar.setOption(barOptions);
            },
            renderItem (params, api) {
                let yValue = api.value(2);
                let start = api.coord([api.value(0), yValue]);
                let size = api.size([api.value(1) - api.value(0), yValue]);
                let style = api.style();
                return {
                    type: 'rect',
                    shape: {
                        x: start[0] + 1,
                        y: start[1],
                        width: size[0] - 2,
                        height: size[1]
                    },
                    style: style
                };
            },
            handleActive (index) {
                this.isactive = index;
                let data = [];
                if (index === 0) {
                    data = this.standard;
                } else if (index === 1) {
                    data = this.quality;
                } else if (index === 2) {
                    data = this.experience;
                }
                this.initBar(data);
            }
        }
    };
</script>

<style lang="less" scoped>
.subdivisionBox {
    width: 100%;
    height: 270px;
    padding: 24px 0 10px 0;
    background: #fff;
}

.subdivisionTop {
    width: 236px;
    margin: 0 auto;
    border-radius: 2px;
    margin-bottom: -8px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.subdivisionTop::after {
    content: "";
    display: block;
    clear: both;
}

.subdivisionTopItem {
    width: 78px;
    height: 30px;
    font-size: 14px;
    text-align: center;
    line-height: 30px;
    color: #36b374;
    border-top: 1px solid #36b374;
    border-bottom: 1px solid #36b374;
    float: left;
}

.subdivisionTopItem.active {
    color: #fff;
    background-color: #36b374;
}

.subdivisionTopItem:first-child {
    border-left: 1px solid #36b374;
    border-radius: 2px 0px 0px 2px;
}

.subdivisionTopItem:last-child {
    border-right: 1px solid #36b374;
    border-radius: 0px 2px 2px 0px;
}

.subdivisionTopItem:not(:last-child) {
    border-right: 1px solid #36b374;
}

.subdivisionBar {
    width: 100%;
    height: 200px;
}
</style>
